import { writable } from 'svelte/store'

export const webName = writable<string>('Trackdesk.com')
